import React from 'react';
import { useAppSelector } from '@hooks/redux';
import { TTextTooltipSalary } from '@pages/employees/components/models/EmployeeComponents';
import { RootState } from '@redux/rootReducer';
import { formatNumber } from '@utils/Number';

export const TextTooltipSalary: React.FC<TTextTooltipSalary> = ({ contractTypeSena }) => {
    const {
        utils: { integral_minimum_wage },
    } = useAppSelector((state: RootState) => state);

    if (contractTypeSena) {
        return <p>{process.env.REACT_APP_SUSTAINABLE_SUPPORT}</p>;
    }

    return <p>Recuerda que el SMMLV del año en curso es de {formatNumber(integral_minimum_wage)}.</p>;
};
